// REA-CI/screens/WelcomeScreen.tsx

import React, { useEffect } from 'react';
import { View, Image, Text, StyleSheet, ImageBackground } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';

type RootStackParamList = {
    WelcomeScreen: undefined;
    LoginScreen: undefined;
};

type WelcomeScreenNavigationProp = StackNavigationProp<RootStackParamList, 'WelcomeScreen'>;

const WelcomeScreen: React.FC = () => {
    const navigation = useNavigation<WelcomeScreenNavigationProp>();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigation.navigate('LoginScreen');
        }, 3000);

        return () => clearTimeout(timer);
    }, [navigation]);

    return (
        <ImageBackground
            source={require('../assets/background/2.png')} // Check if this path is correct
            style={styles.background}
        >
            <View style={styles.container}>
                {/* Add testID for the logo image */}
                <Image
                    testID="REA-logo"  // Add this line to help with testing
                    source={require('../assets/logo.png')} // Check if this path is correct
                    style={styles.logo}
                />
                <Text style={styles.versionText}>Version 1.0.1</Text>
                <Text style={styles.welcomeText}>Welcome to REA!</Text>
                <Text style={styles.descriptionText}>
                    Your trusted platform for buying, selling, and renting properties in Côte d'Ivoire.
                </Text>
            </View>
        </ImageBackground>
    );
};

const styles = StyleSheet.create({
    background: {
        flex: 1,
        resizeMode: 'cover',
    },
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'transparent',
    },
    logo: {
        width: 150,
        height: 150,
        resizeMode: 'contain',
        marginBottom: 5,
    },
    versionText: {
        fontSize: 10,
        color: '#ffffff',
        textAlign: 'center',
        marginBottom: 20,
        fontFamily: 'Aventra-Bold', // Custom font
    },
    welcomeText: {
        fontSize: 24,
        fontWeight: 'bold',
        color: '#333',
        textAlign: 'center',
        marginBottom: 10,
        fontFamily: 'Aventra-Bold', // Custom font
    },
    descriptionText: {
        fontSize: 14,
        color: '#ffffff',
        textAlign: 'center',
        paddingHorizontal: 20,
        fontFamily: 'Aventra-Bold', // Custom font
    },
});

export default WelcomeScreen;